type PickemQuestionFixture = {
  sport_match_data?: { scheduledDate?: string | null } | null;
};

type PickemEntrySource = {
  pickem_status?: string | null;
  status?: string | null;
  start_utc?: string | null;
  start?: string | null;
  questions?: PickemQuestionFixture[];
};

const CLOSED_STATUSES = new Set(['INPLAY', 'COMPLETE', 'COMPLETED', 'CANCELLED', 'FINAL']);

function parseUtc(value: string | null | undefined): Date | null {
  if (value == null || value === '') return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Earliest UTC moment after which users may no longer enter or edit picks. */
export function getPickemEntryLockUtc(pickem: PickemEntrySource | undefined): Date | null {
  if (!pickem) return null;

  const candidates: Date[] = [];
  const pickemStart = parseUtc(pickem.start_utc ?? pickem.start ?? undefined);
  if (pickemStart) candidates.push(pickemStart);

  for (const question of pickem.questions ?? []) {
    const fixtureStart = parseUtc(question.sport_match_data?.scheduledDate ?? undefined);
    if (fixtureStart) candidates.push(fixtureStart);
  }

  if (candidates.length === 0) return null;
  return new Date(Math.min(...candidates.map(d => d.getTime())));
}

export function isPickemEntryClosed(
  pickem: PickemEntrySource | undefined,
  now: Date = new Date()
): boolean {
  if (!pickem) return false;

  const status = String(pickem.pickem_status ?? pickem.status ?? '').toUpperCase();
  if (CLOSED_STATUSES.has(status)) return true;

  const lockUtc = getPickemEntryLockUtc(pickem);
  return lockUtc != null && now.getTime() >= lockUtc.getTime();
}
